import { NumberOfInstallmentsOptions } from '~/utils/selectOptions'
import { UPDATE_CREATE_ACCOUNT_FORM } from './types'

export interface CreateAccountFormValues {
  // FIRST PAGE
  cnpj: string,
  origin: string,
  companyName: string,
  fantasyName: string,
  monthlyIncome: string,
  foundationDate: string,
  hasMutualAccount: boolean,

  // SECOND PAGE
  requestedAmountCents: string,
  numberOfInstallments: NumberOfInstallmentsOptions,
  loanMotive: string,

  // THIRD PAGE
  responsibleCpf: string,
  responsibleName: string,

  // FOURTH PAGE
  phone: string,
  companyEmail: string,
  password: string,
  passwordConfirmation: string
}

export interface CreateAccountFormState {
  form: CreateAccountFormValues
}

interface Action {
  payload: CreateAccountFormValues,
  type: string
}

export const CREATE_ACCOUNT_FORM_INITIAL_STATE: CreateAccountFormState = {
  form: {
    cnpj: '',
    phone: '',
    password: '',
    loanMotive: '',
    fantasyName: '',
    companyName: '',
    companyEmail: '',
    monthlyIncome: '',
    foundationDate: '',
    responsibleCpf: '',
    responsibleName: '',
    hasMutualAccount: false,
    requestedAmountCents: '',
    numberOfInstallments: '',
    passwordConfirmation: '',
    origin: 'mutual'
  }
}

export const createAccountFormReducer = (prevState = CREATE_ACCOUNT_FORM_INITIAL_STATE, action: Action) => {
  switch (action.type) {
    case UPDATE_CREATE_ACCOUNT_FORM:
      return {
        ...CREATE_ACCOUNT_FORM_INITIAL_STATE,
        form: { ...prevState.form, ...action.payload }
      }
    default:
      return prevState
  }
}
